import { all, takeEvery, put, call } from 'redux-saga/effects';
import moment from 'moment';
import actions from './actions';
import Api from '../../helpers/api';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';
import notificationsActions from '../notifications/actions';
import notificationsCenterActions from '../../containers/notificationsCenter/actions';
import { LAST_THEME_FETCH_DATE_KEY } from '../../helpers/localStorageKeys.const';

const api = new Api('notifications/:id/read');
const themeApi = new Api('branding_settings');

function* notificationMarkAsRead({ payload }) {
  const { id, query, shouldReloadTopNav } = payload;

  try {
    const result = yield call(sendRequest, api.updateItem, { id }, notificationsActions.REQUEST_ERROR);

    if (result && result.data) {
      if (query) {
        yield put(notificationsCenterActions.loadData({ query }));
      }

      if (shouldReloadTopNav) {
        yield put(notificationsCenterActions.loadTopNavNotificationsRequest());
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* onLoadTheme() {
  try {
    const result = yield call(sendRequest, themeApi.load, {}, notificationsActions.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      localStorage.setItem(LAST_THEME_FETCH_DATE_KEY, moment().toISOString());
      yield put(actions.loadThemeSuccess(result.data.success.data));
    } else {
      yield put(actions.loadThemeError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export { onLoadTheme };

export default function* rootSaga() {
  yield all([takeEvery(actions.NOTIFICATION_MARK_AS_READ, notificationMarkAsRead)]);
}
